import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import Routes from './routes';
import { ToastContainer } from 'react-toastify';

import './utils/i18n';
import 'react-toastify/dist/ReactToastify.css';
import './components/styles/Global.css';
import './components/styles/Slides.css';

function App() {
  const isMobile = window.screen.width < 620;

  useEffect(() => {
    const script = document.createElement('script');

    if (
      process.env.REACT_APP_ENV === 'build-prod' ||
      process.env.REACT_APP_ENV === 'prod'
    ) {
      script.type = 'text/javascript';
      script.crossOrigin = 'anonymous';
      script.src =
        'https://js-cdn.dynatrace.com/jstag/1624d0f62e6/bf82227shx/ee65062b9c0b78e8_complete.js';
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      if (document?.body) {
        document?.body?.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    if (isMobile) return;

    if (
      process.env.REACT_APP_ENV === 'build-prod' ||
      process.env.REACT_APP_ENV === 'prod'
    ) {
      const script = document.createElement('script');
      script.id = 'com-purple-metrics-script';
      script.defer = true;
      script.src =
        'https://dashboard.purplemetrics.com.br/widget/js/widget.js?v=' +
        Date.now();
      script.type = 'module';
      document.head.appendChild(script);

      window._pm =
        window._pm ||
        function () {
          (window._pm.q = window._pm.q || []).push(arguments);
        };

      window._pm('init', {
        companyId: '634118e1-c91a-46f0-a3b7-f78d874aaead',
        segmentId: 403,
        zIndex: 999999999,
        zIndexClosed: 999999999,
      });
    } else {
      const script = document.createElement('script');
      script.id = 'com-purple-metrics-script';
      script.defer = true;
      script.src =
        'https://dashboard.purplemetrics.com.br/widget/js/widget.js?v=' +
        Date.now();
      script.type = 'module';
      document.head.appendChild(script);

      window._pm =
        window._pm ||
        function () {
          (window._pm.q = window._pm.q || []).push(arguments);
        };

      window._pm('init', {
        companyId: '634118e1-c91a-46f0-a3b7-f78d874aaead',
        segmentId: 403,
        zIndex: 999999999,
        zIndexClosed: 9999999,
        isDebug: true,
      });
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="background">
          <ToastContainer
            className="toast-container-push"
            position="top-right"
            autoClose={10000}
            hideProgressBar={false}
            rtl={false}
            newestOnTop
            closeOnClick
            pauseOnVisibilityChange
            draggable
            pauseOnHover
            enableMultiContainer
          />
          <Routes />
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
